import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth } from "./services/firebase";
import { db } from "./services/firebase";
import CotizadorForm from "./components/CotizadorForm";
import Login from "./components/Login";

function App() {
  const [user, setUser] = useState(null);
  const [rol, setRol] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);

        // 🔥 Leer rol desde Firestore
        const userRef = doc(db, "users", currentUser.uid);
        const snap = await getDoc(userRef);

        if (snap.exists()) {
          const data = snap.data();
          setRol(data.role);
        } else {
          console.warn("⚠️ Usuario sin documento en Firestore");
          setRol("user");
        }
      } else {
        setUser(null);
        setRol(null);
      }

      setLoading(false);
    });

    return unsubscribe;
  }, []);

  if (loading)
    return <p style={{ textAlign: "center", marginTop: "50px" }}>Cargando...</p>;

  return (
    <>
      {user ? (
        <div style={{ position: "relative" }}>
          {/* Botón cerrar sesión */}
          <div
            onClick={() => signOut(auth)}
            style={{
              position: "absolute",
              top: "4rem",
              right: "1rem",
              backgroundColor: "#111111",
              color: "white",
              padding: "0.5rem 1rem",
              borderRadius: "0.5rem",
              cursor: "pointer",
              fontWeight: "bold",
              zIndex: 1000,
            }}
          >
            Cerrar sesión
          </div>

          {/* 👉 AQUÍ YA ESTÁS VALIDANDO EL ROL */}
          <CotizadorForm rol={rol} />
        </div>
      ) : (
        <Login onLogin={() => {}} />
      )}
    </>
  );
}

export default App;

